(function() {
  'use strict';
  
  // Newsletter Popup Handler
  function NewsletterPopup(element) {
    this.element = element;
    this.options = JSON.parse(element.getAttribute('data-section-settings'));
    this.pageOverlayElement = document.querySelector('.PageOverlay');
    
    if (!this.pageOverlayElement) {
      // Create PageOverlay if it doesn't exist
      this.pageOverlayElement = document.createElement('div');
      this.pageOverlayElement.className = 'PageOverlay';
      document.body.appendChild(this.pageOverlayElement);
    }
    
    this._attachListeners();
    this._init();
  }
  
  NewsletterPopup.prototype._attachListeners = function() {
    var self = this;
    
    // Close button
    var closeButton = this.element.querySelector('[data-action="close-popup"]');
    if (closeButton) {
      closeButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        self._closePopup();
      });
    }
    
    // Close on overlay click
    this.closeOverlayHandler = function(e) {
      if (e.target === self.pageOverlayElement) {
        self._closePopup();
      }
    };
    
    // Prevent clicks on popup content from closing
    this.element.addEventListener('click', function(e) {
      e.stopPropagation();
    });
    
    // Close on ESC key
    this.escKeyHandler = function(e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        self._closePopup();
      }
    };
  };
  
  NewsletterPopup.prototype._init = function() {
    try {
      // Check if popup should open via hash
      if (window.location.hash === '#newsletter-popup' && window.theme && window.theme.pageType !== null) {
        this._openPopup();
        return;
      }
      
      // Check if should show only once
      if (this.options.showOnlyOnce) {
        if (localStorage.getItem('themePopup') !== null) {
          return; // Already shown
        }
      }
      
      // Open after delay
      var self = this;
      setTimeout(function() {
        self._openPopup();
      }, this.options.apparitionDelay * 1000);
    } catch (e) {
      // Silently fail if localStorage is not available
    }
  };
  
  NewsletterPopup.prototype._openPopup = function() {
    this.element.setAttribute('aria-hidden', 'false');
    
    // Mark as shown in localStorage
    try {
      localStorage.setItem('themePopup', 'true');
    } catch (e) {
      // localStorage not available
    }
    
    // Show overlay
    if (this.pageOverlayElement) {
      this.pageOverlayElement.classList.add('is-visible');
      this.pageOverlayElement.addEventListener('click', this.closeOverlayHandler);
    }
    
    // Add ESC key listener
    document.addEventListener('keydown', this.escKeyHandler);
    
    // Prevent body scroll - add to both html and body
    document.documentElement.classList.add('no-scroll');
    document.body.classList.add('no-scroll');
  };
  
  NewsletterPopup.prototype._closePopup = function() {
    this.element.setAttribute('aria-hidden', 'true');
    
    // Hide overlay
    if (this.pageOverlayElement) {
      this.pageOverlayElement.classList.remove('is-visible');
      this.pageOverlayElement.removeEventListener('click', this.closeOverlayHandler);
    }
    
    // Remove ESC key listener
    document.removeEventListener('keydown', this.escKeyHandler);
    
    // Restore body scroll - remove from both html and body
    document.documentElement.classList.remove('no-scroll');
    document.body.classList.remove('no-scroll');
  };
  
  // Initialize when DOM is ready
  function initNewsletterPopup() {
    var popupElement = document.querySelector('[data-section-type="newsletter-popup"]');
    if (popupElement) {
      new NewsletterPopup(popupElement);
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNewsletterPopup);
  } else {
    initNewsletterPopup();
  }
  
  // Lazy load images
  function initLazyLoad() {
    var lazyImages = document.querySelectorAll('.Image--lazyLoad[data-src]');
    
    if ('IntersectionObserver' in window) {
      var imageObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var img = entry.target;
            var srcset = img.getAttribute('data-src');
            var sizes = img.getAttribute('data-sizes');
            var widths = img.getAttribute('data-widths');
            
            if (srcset) {
              img.srcset = srcset;
              if (sizes) img.sizes = sizes;
              img.classList.add('Image--fadeIn');
              imageObserver.unobserve(img);
            }
          }
        });
      });
      
      lazyImages.forEach(function(img) {
        imageObserver.observe(img);
      });
    } else {
      // Fallback for browsers without IntersectionObserver
      lazyImages.forEach(function(img) {
        var srcset = img.getAttribute('data-src');
        if (srcset) {
          img.srcset = srcset;
          img.classList.add('Image--fadeIn');
        }
      });
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLazyLoad);
  } else {
    initLazyLoad();
  }
})();
